import type { ReactElement } from 'react';

export default function renderText(text: string, highlight?: string): (ReactElement | string)[] {
  if (!highlight) {
    return [text];
  }

  const lowerCaseText = text.toLowerCase();
  const queryPosition = lowerCaseText.indexOf(highlight.toLowerCase());
  if (queryPosition < 0) {
    return [text];
  }

  return [
    text.substring(0, queryPosition),
    <span key="match" className="matching-text-highlight">
      {text.substring(queryPosition, queryPosition + highlight.length)}
    </span>,
    text.substring(queryPosition + highlight.length),
  ];
}
